import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { toast } from "sonner";
import { useCart } from "../context/CartContext";
import { imgSrc, money } from "../lib/api";

export default function ProductCard({ product, index = 0 }) {
  const { add } = useCart();
  const nav = useNavigate();
  const needsOptions = product.sizes?.length > 0 || product.per_letter || product.addons?.length > 0 || product.flavors?.length > 0;
  const onAdd = () => {
    if (needsOptions) return nav(`/product/${product.id}`);
    add(product, 1);
    toast.success(`${product.name} added to cart`);
  };
  return (
    <article
      className="group panel rise flex flex-col overflow-hidden transition-transform duration-300 hover:-translate-y-1.5"
      style={{ animationDelay: `${index * 70}ms` }}
      data-testid={`product-card-${product.id}`}
    >
      <Link to={`/product/${product.id}`} className="relative block aspect-square overflow-hidden" data-testid={`product-card-link-${product.id}`}>
        <img src={imgSrc(product.image_url)} alt={product.name} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
        <span className="absolute left-2 top-2 rounded-full bg-black/75 px-2.5 py-0.5 text-[10px] font-extrabold text-white backdrop-blur sm:left-3 sm:top-3 sm:px-3 sm:py-1 sm:text-xs">{product.category}</span>
      </Link>
      <div className="flex flex-1 flex-col gap-2 p-3 sm:gap-3 sm:p-5">
        <Link to={`/product/${product.id}`} className="font-display text-base leading-tight hover:text-[var(--pink)] sm:text-xl">{product.name}</Link>
        <div className="mt-auto flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <span className="font-display text-xl text-[var(--pink)] sm:text-2xl" data-testid={`product-card-price-${product.id}`}>
            {needsOptions && product.sizes?.length > 1 && <span className="mr-1 font-sans text-xs font-bold text-white/60">from</span>}
            {money(product.price)}
            {product.per_letter && <span className="ml-1 font-sans text-xs font-bold text-white/60">/letter</span>}
          </span>
          <button onClick={onAdd} className="btn-royal w-full !px-4 !py-2.5 text-sm sm:w-auto sm:!py-2" data-testid={`add-to-cart-${product.id}`}>
            <Plus className="h-4 w-4" /> {needsOptions ? "Customize" : "Add"}
          </button>
        </div>
      </div>
    </article>
  );
}
